import React from "react";
import FormText from "./form/formText.component";
import { useDispatch, useSelector } from "react-redux";
import { enterPractising } from "../actions/index";
import { stateProps } from "../types";
import ContainerBox from "./common/containerBox.component";
import FormSingleInput from "./form/formSingleInput.component";

const Practise: React.FC = () => {
  const dispatch = useDispatch();

  const pracLocation = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.practising
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterPractising(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText
          number={"14"}
          title={"Where are you currently practising?"}
          optional={"(Optional)"}
        />
        <FormSingleInput
          value={pracLocation}
          onInputChange={onInputChange}
          placeholder={"Your practicing locations"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Practise;
